module.exports = __webpack_public_path__ + "img/spain.79b0098d.svg";